import styled from "styled-components";
import DiscordImg from "./img/icons8-logo-discord-30.png";
import FacebookImg from "./img/icons8-facebook-novo-30.png";
import InstagramImg from "./img/icons8-instagram-24.png";
import GoldStarImg from "./img/goldstar.png"
import { useContext } from "react";
import { PageContext } from "../Context/PageContext";
import Home from "../Content/Home/Home";

function FooteBan(){

    const {setPage} = useContext(PageContext);

    const currentYear = new Date().getFullYear();

    return(
        <FooterContainer>
		    <FirstSection>
                <LogoContainer>

                    <TitleIconContainer>
                        <LionsRagIcon img={GoldStarImg}/>
                        <LionsRagSpan>MCCT - EEIMVR</LionsRagSpan>
                    </TitleIconContainer>

                    <span>Pesquisa para Curso de Mestrado</span>
                </LogoContainer>

                <UtilityLinksContainter>
                    <UtilityLink>Pesquisador</UtilityLink>
                    <UtilityLink>Orientadores</UtilityLink>
                    <UtilityLink onClick={() => { setPage(<Home/>)}}>Home</UtilityLink>
                </UtilityLinksContainter>

                <SocialMediaContainter>

                    <MediaItemContainter>
                        <SocialMediaIcon img={FacebookImg} onClick={() => window.open('#', "_self")}/>
                        <span>Facebook</span>
                    </MediaItemContainter>
                    

                    <MediaItemContainter>
                        <SocialMediaIcon img={InstagramImg} onClick={() => window.open('#', "_self")}/>
                        <span>Instagram</span>
                    </MediaItemContainter>
                    
                </SocialMediaContainter>
            </FirstSection>

            <CopyRightSpan>{currentYear}. Pesquisa Acâdemica do Curso de Mestrado da EEIMVR.<br/>
			Departamento de Pós - Graduação em Modelagem Computacional em Ciência e Tecnologia.</CopyRightSpan>
        </FooterContainer>
    );
};

const FooterContainer = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    padding: 0px 0px;
	background-color: rgb(5, 88, 156);
	opacity: 1.0;
    z-index: 0;
	transition-duration: 1s;
	box-shadow: 15px -2px 7px 2px rgba(0,0,0,0.7);
    width: 100%;
    margin: 100px 0 0px 0;
    padding: 30px 0;


`;

const CopyRightSpan = styled.span`
    font-size: 11pt;
    text-align: center;

    @media(max-width: 1000px) {
        margin-bottom: 30px;
    }

`

const FirstSection = styled.div`
    display: flex;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding: 0 0 30px 0;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    width: 1000px;

    @media(max-width: 1000px) {
      flex-direction: column;
      margin-bottom: 30px;
    }

`

const LogoContainer = styled.div`
    display: flex;
    width: 270px;
    align-items: center;
    flex-direction: column;
    //border: solid;

    @media(max-width: 1000px) {
      margin-bottom: 30px;
    }
`

const TitleIconContainer = styled.div`
    display: flex;
    width: 220px;
    justify-content: start;
    align-items: center;
    //border: solid;
    margin-bottom: 5px;
`

const LionsRagIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 40px;
    height: 40px;
    //margin-bottom: 5px;
    margin-right: 10px;

`

const LionsRagSpan = styled.span`
    font-size: 16pt;
    font-weight: bold;
`

const UtilityLinksContainter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    width: 360px;

    @media(max-width: 1000px) {
      margin-bottom: 30px;
    }
`

const UtilityLink = styled.span`
    font-size: 12pt;
    //border: solid;
    padding: 10px 10px;
    border-radius: 5px;
    transition: .3s ease-in-out;

    &:hover {
        background-color: rgba(0,0,0,.3);

    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const SocialMediaContainter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 280px;
    
`

const MediaItemContainter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 10px;
    border-radius: 5px;
    transition: .3s ease-in-out;

    &:hover {
        background-color: rgba(0,0,0,.3);

    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`
const SocialMediaIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-bottom: 5px;

`


export default FooteBan;